// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: a Konvo panel request ends in a "-# Konvo panel · …" line that tells the assistant where
// it was asked from (starter, chat, mail, meeting ids). The assistant reads it; people should not
// see it when the request is shown back (the Assistant DM, Home's thread, recent questions). No
// imports, so message rendering can use it without pulling in the panel.

/** A panel message without its context line, for showing it back. */
export function stripPanelContext(content: string): string {
	return content.replace(/\n*-# Konvo panel ·[^\n]*\s*$/u, '').trim();
}
